import { Divider, Drawer, Space, Select, Tooltip, Button, Checkbox, Spin } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import BMInput from "../../comps/BMInput";
import PositionAlign from "../../UI/PositionAlign";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import { fetchImage } from "../../../utils/Api";
import Images from "../../UI/Images";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import { hasLink, previewLink, tt_ig_display, tt_ig_gap_x, tt_ig_gap_y, tt_ig_padding_x, tt_ig_padding_y, tt_name_block_warning } from "../../../utils/Utils";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import PresetPicker from "../../../globals/styles/PresetPicker";
import Html from "../../../utils/Html";
import MobileSelector from "../../UI/MobileSelector";
import LinkPicker from "../../../globals/styles/LinkPicker";

export default function ImageGrid(props) {
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0, view = "desktop", setView = () => { } } = props;
    const [template,] = useTemplate();
    const [mobile, setMobile] = useState(false)
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        width = 400,
        height = 300,
        padding_y = 0,
        padding_x = 0,
        horizontal_align = "center",
        vertical_align = "center",
        size = "cover",
        gap_y = 10,
        gap_x = 10,
        justify = "center",
        background_colour = 0,
        images = [
            { path: "https://bookmanager.com/i/sample_content/placeholder.jpg", alt: "", link: "", tab: true, headline: "", paragraph: "", button_label: "" },
            { path: "https://bookmanager.com/i/sample_content/placeholder.jpg", alt: "", link: "", tab: true, headline: "", paragraph: "", button_label: "" },
            { path: "https://bookmanager.com/i/sample_content/placeholder.jpg", alt: "", link: "", tab: true, headline: "", paragraph: "", button_label: "" }
        ],
        image_radius = 0,

        // New
        headline_preset = 0,
        button_preset = 0,
        paragraph_preset = 0,
        align = "center",
        headline_position = "bottom",
        paragraph_position = "bottom",
        button_position = "bottom",
        reverse_wrap = false,
        mobile_image_height = 100,
        allow_mobile_overrides = false,
        link_style = 0,

    } = data;




    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const linkOut = (_image) => {
        if (hasLink(_image.link)) {
            window.open(previewLink(_image.link), (_image.tab) ? "_blank" : "_self");
        }
    }

    const drawImage = (_image, _index) => {
        let _coverStyle = {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: (hasLink(_image.link)) ? "pointer" : "default",
            objectFit: "cover",
            height: (allow_mobile_overrides && view !== "desktop") ? mobile_image_height + "px" : height + "px",
            width: (view !== "desktop") ? "100%" : width + "px",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url('${fetchImage(_image.path)}')`,
            backgroundSize: size,
            backgroundPosition: vertical_align + " " + horizontal_align,
            borderRadius: image_radius + "px",
            overflow: "hidden"
        }





        const drawText = (_position = "bottom", _image) => {

            return (
                <>
                    {(headline_position === _position && _image.headline &&
                        <h2 style={{ "display": "block" }} className={"bm-txt-" + headline_preset} >
                            {_image.headline}
                        </h2>
                    )}
                    {(paragraph_position === _position && _image.paragraph &&
                        <div className={"bm-component  bm-txt-" + paragraph_preset} >
                            <Html anchor={"bm-lnkin-" + link_style} html={_image.paragraph} />
                        </div>
                    )}
                    {(button_position === _position && _image.button_label &&
                        <div style={{ "display": "block" }}>
                            <div className="shim" /><div className="shim" />
                            <Button onClick={() => linkOut()} className={"bm-btn-" + button_preset} >{_image.button_label}</Button>
                        </div>
                    )}
                </>
            )

        }

        return (
            <div>
                <div style={{ "width": (view !== "desktop") ? "100%" : width + "px", "textAlign": align }}>
                    {drawText("top", _image)}
                </div>
                <div tabIndex={(hasLink(_image.link) ? 0 : null)} aria-label={(!hasLink(_image.link)) ? _image.alt : (_image.tab) ? "Visit link (opens in a new tab)" : "Visit link"} className={(hasLink(_image.link)) ? "bm-img-link" : ""} title={_image.alt} onKeyDown={(e) => { if (e.key === "Enter") { linkOut(_image) } }} onClick={() => linkOut(_image)} style={_coverStyle} key={_index}>
                    <div style={{ "width": (view !== "desktop") ? "100%" : width + "px", "textAlign": align }}>
                        {drawText("middle", _image)}
                    </div>
                </div>
                <div style={{ "width": (view !== "desktop") ? "100%" : width + "px", "textAlign": align }}>
                    {drawText("bottom", _image)}
                </div>
            </div>
        )
    }

    const drawRender = () => {
        const gridStyle = {
            background: getColor(background_colour, template),
            display: 'flex',
            flexWrap: (reverse_wrap) ? "wrap-reverse" : "wrap",
            flexDirection: (view !== "desktop") ? (reverse_wrap) ? "column-reverse" : "column" : (reverse_wrap) ? "row-reverse" : "",
            justifyContent: justify,
            gap: `${gap_y}px ${gap_x}px`,
            padding: `${padding_y}px ${padding_x}px`,
        };

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={gridStyle}>
                    {images.map((item, index) => {
                        return drawImage(item, index);
                    })}
                </div>
            </div>
        )
    }


    const drawDesktop = () => {

        return (
            <div>
                {/* IMAGES */}
                <Images container={container} paragraph_preset={paragraph_preset} link_style={link_style} extra data={data} setData={setData} images={images} />
                <div className="shim" /> <div className="shim" />
                {/* BACKGROUND ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE ALIGN & DISPLAY</Divider>
                <div className="float-flex">
                    <Space>
                        <PositionAlign value={horizontal_align} onChange={(e) => setData({ ...data, "horizontal_align": e })} />
                        <PositionAlign type="vertical" value={vertical_align} onChange={(e) => setData({ ...data, "vertical_align": e })} />
                    </Space>
                    <div>&nbsp;&nbsp;&nbsp;</div>
                    <Tooltip title={tt_ig_display}>
                        <Select value={size} onChange={(e) => setData({ ...data, "size": e })} size="small" style={{ "width": "100%" }} >
                            <Select.Option key="cover" value="cover"><small>Cover</small></Select.Option>
                            <Select.Option key="contain" value="contain"><small>Contain</small></Select.Option>
                            <Select.Option key="initial" value="initial"><small>Initial</small></Select.Option>
                        </Select>
                    </Tooltip>
                </div>
                <div className="shim" /> <div className="shim" /><div className="shim" />
                {/* GUTTER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE GAP</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <BMInput value={gap_x} onChange={(_v) => setData({ ...data, "gap_x": _v })} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_ig_gap_x} >X</Tooltip>} />
                        <BMInput value={gap_y} onChange={(_v) => setData({ ...data, "gap_y": _v })} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_ig_gap_y}>Y</Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* WIDTH / HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE WIDTH / HEIGHT</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <BMInput value={width} onChange={(_v) => setData({ ...data, "width": _v })} number min={100} max={1248} prefix="WIDTH" />
                        <BMInput value={height} onChange={(_v) => setData({ ...data, "height": _v })} number min={100} max={1248} prefix="HEIGHT" />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />

                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                <PresetPicker value={headline_preset} onChange={(e) => setData({ ...data, "headline_preset": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH PRESET</Divider>
                <PresetPicker value={paragraph_preset} onChange={(e) => setData({ ...data, "paragraph_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_style} onChange={(e) => setData({ ...data, "link_style": e })} />
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={button_preset} onChange={(e) => setData({ ...data, "button_preset": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE POSITION</Divider>
                <Select value={headline_position} onChange={(e) => setData({ ...data, "headline_position": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"top"} value={"top"}><small>Above Image</small></Select.Option>
                    <Select.Option key={"middle"} value={"middle"}><small>Over Image</small></Select.Option>
                    <Select.Option key={"bottom"} value={"bottom"}><small>Below Image</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH POSITION</Divider>
                <Select value={paragraph_position} onChange={(e) => setData({ ...data, "paragraph_position": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"top"} value={"top"}><small>Above Image</small></Select.Option>
                    <Select.Option key={"middle"} value={"middle"}><small>Over Image</small></Select.Option>
                    <Select.Option key={"bottom"} value={"bottom"}><small>Below Image</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON POSITION</Divider>
                <Select value={button_position} onChange={(e) => setData({ ...data, "button_position": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"top"} value={"top"}><small>Above Image</small></Select.Option>
                    <Select.Option key={"middle"} value={"middle"}><small>Over Image</small></Select.Option>
                    <Select.Option key={"bottom"} value={"bottom"}><small>Below Image</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN</Divider>
                <div className="float-flex">
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                </div>

                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>

                {/* GRID */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">GRID ALIGN</Divider>
                <Select value={justify} onChange={(e) => setData({ ...data, "justify": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"center"} value={"center"}><small>Centre</small></Select.Option>
                    <Select.Option key={"start"} value={"start"}><small>Left</small></Select.Option>
                    <Select.Option key={"end"} value={"end"}><small>Right</small></Select.Option>
                    <Select.Option key={"space-between"} value={"space-between"}><small>Space Between</small></Select.Option>
                    <Select.Option key={"space-evenly"} value={"space-evenly"}><small>Space Evenly</small></Select.Option>
                    <Select.Option key={"space-around"} value={"space-around"}><small>Space Around</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / BORDER RADIUS</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput width={"40px"} value={image_radius} onChange={(e) => setData({ ...data, "image_radius": e })} number min={0} max={1000} prefix="RADIUS" />
                    </Space>
                    <div></div>
                </div>


                {/* LINK TARGET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">Reverse</Divider>
                <Checkbox checked={reverse_wrap} onChange={(e) => setData({ ...data, "reverse_wrap": e.target.checked })} ><small>Reverse?</small></Checkbox>
                <div className="shim" /> <div className="shim" />
            </div>
        )
    }

    const drawMobile = () => {

        return (
            <div>
                <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                <div className="shim" /><div className="shim" />
                <Spin spinning={!allow_mobile_overrides} indicator={<></>}>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEIGHT</Divider>
                    <div className="float-flex">
                        <BMInput width={"50px"} value={mobile_image_height} onChange={(e) => setData({ ...data, "mobile_image_height": e })} number min={100} max={1000} prefix="H" />
                    </div>
                </Spin>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {(mobile && drawMobile())}
                {(!mobile && drawDesktop())}
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}